@if (!hide()) {
  @if (isPlatformBrowser(platformId)) {
    <nouislider (change)="handleChange($event)" [ngModel]="range()"
                [config]="config"
                [max]="state().range.max ?? 0"
                [min]="state().range.min ?? 0"/>
  }
}
